// A function to run after the filters update
const onFilterUpdate = () => {
  if (typeof updateFilterImages === "function") {
    updateFilterImages();
  }
};

const productGridContainer = document.getElementById("ProductGridContainer");
// ===================================================
//  MUTATIONOBSERVER: DETECT CHANGES IN THE GRID
// ===================================================
const gridObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      const addedNodes = Array.from(mutation.addedNodes);

      // Filter out nodes that have data-processed or data-cloned
      const unprocessedNodes = addedNodes.filter(
        (node) =>
          node.nodeType === 1 &&
          !node.hasAttribute("data-processed") &&
          !node.hasAttribute("data-cloned")
      );

      // If any new unprocessed nodes are found, re-run filter logic
      if (unprocessedNodes.length > 0) {
        onFilterUpdate();
        getMatchingVariants();
        break;
      }
    }
  }
});

gridObserver.observe(productGridContainer, {
  childList: true,
  subtree: true,
});

function getVariantsByFilters(variants, selectedColors, available24hIDs) {
  let filteredVariants = variants.filter(
    (variant) => variant.available === true
  );

  // 1) Filter by selected colors (OR condition)
  if (selectedColors && selectedColors.length > 0) {
    filteredVariants = filteredVariants.filter((variant) =>
      selectedColors.some((color) => color === variant.title.toLowerCase())
    );
  }

  // 2) Filter by 24h availability (if required)
  const productGridContainer = document.getElementById("ProductGridContainer");
  if (
    productGridContainer?.classList.contains("available-now") &&
    available24hIDs &&
    available24hIDs.length > 0
  ) {
    filteredVariants = filteredVariants.filter((variant) =>
      available24hIDs.includes(variant.id)
    );
  }

  if (window.sale_page) {
    filteredVariants = filteredVariants.filter(
      (variant) => variant.compare_at_price != null
    );
  }
  return filteredVariants;
}

function applySorting() {
  const sortBy = document.querySelector("#SortBy").value; // Get selected sort option
  const gridItems = document.querySelectorAll(".grid__item");

  // Determine sorting logic
  gridItems.forEach((item, index) => {
    const price = parseFloat(item.getAttribute("data-price"));
    const title = item.getAttribute("data-title");

    if (isNaN(price) || !title) return; // Skip if price or title is missing{
    // Set the order based on the selected criteria
    if (sortBy === "price-ascending") {
      item.style.order = price; // Use price as the order value
      // item.style.setProperty("--animation-order", price);
    } else if (sortBy === "price-descending") {
      item.style.order = -price; // Reverse the order by using negative values
      // item.style.setProperty("--animation-order", -price);
    } else if (sortBy === "title-ascending") {
      item.style.order = title.charCodeAt(0); // Use ASCII value of title for ordering
      // item.style.setProperty("--animation-order", title.charCodeAt(0));
    } else if (sortBy === "title-descending") {
      item.style.order = -title.charCodeAt(0); // Reverse ASCII order
      // item.style.setProperty("--animation-order", -title.charCodeAt(0));
    } else {
      // item.style.setProperty("--animation-order", index);
    }
  });

  console.log("Applied sorting:", sortBy);
}

function openFilter(event, filter) {
  event.preventDefault();
  button = event.currentTarget;
  document
    .querySelectorAll(".facets-buttons button[open]")
    .forEach((openButton) => {
      openButton.removeAttribute("open");
    });
  document.querySelectorAll(`[data-filter]`).forEach((f) => {
    if (f.getAttribute("data-filter") != filter) {
      f.removeAttribute("open");
    }
  });

  filter = document.querySelector(`[data-filter="${filter}"]`);
  if (filter.hasAttribute("open")) {
    filter.removeAttribute("open");
    button.removeAttribute("open");
  } else {
    filter.querySelector("summary").click();
    button.setAttribute("open", "");
  }
}

function getCurrentFilters() {
  const filteredAttributes = document.querySelectorAll(
    ".facets__item input:checked"
  );
  const gridContainer = document.querySelector(".product-grid-container");

  // Toggle .filtered class on .product-grid-container
  if (filteredAttributes.length === 0) {
    gridContainer?.classList.remove("swyft-filtered");
    gridContainer?.classList.remove("hide-main-product");
    document.querySelectorAll("details").forEach((detail) => {
      detail.removeAttribute("filtered");
    });
  } else {
    gridContainer?.classList.add("swyft-filtered");
  }

  const selectedColors = [];
  const filterGroups = {};
  const checkedFilters = document.querySelectorAll(
    "#FacetFiltersForm input[checked]:not(.mobile-facets__checkbox):not([name='filter.p.m.swyft.product_model']):not([name='filter.p.product_type']):not([name='filter.p.m.swyft.product_seating_capacity'])"
  );

  checkedFilters.forEach((input) => {
    input.closest("details").removeAttribute("filtered");
  });

  // Group checked inputs by their name
  checkedFilters.forEach((input) => {
    const name = input.getAttribute("name");
    if (!filterGroups[name]) {
      filterGroups[name] = [];
    }
    const sibling = input.nextElementSibling;
    if (sibling) {
      const colors = sibling.getAttribute("data-colours");
      if (colors) {
        const colorArray = colors
          .split(",")
          .map((color) => color.trim().toLowerCase());
        filterGroups[name].push(...colorArray);
      }
    }
  });

  // Intersect results if input names differ
  const filterNames = Object.keys(filterGroups);
  if (filterNames.length === 1) {
    // All inputs have the same name; merge all colors
    selectedColors.push(...new Set(filterGroups[filterNames[0]]));
  } else {
    // Different input names; find intersection
    const intersectedColors = filterNames.reduce(
      (intersection, name, index) => {
        const colorSet = new Set(filterGroups[name]);
        return index === 0
          ? colorSet
          : new Set([...intersection].filter((color) => colorSet.has(color)));
      },
      new Set()
    );
    selectedColors.push(...intersectedColors);
  }

  // Set "filtered" attribute for each input's closest details element
  checkedFilters.forEach((input) => {
    input.closest("details").setAttribute("filtered", "");
  });

  if (filter_colours.length != 0 && filter_material_colours.length == 0) {
    const filterColorsArray = filter_colours.map((color) =>
      color.trim().toLowerCase()
    );

    // If `selectedColors` already has values, keep only the intersection
    if (selectedColors.length > 0) {
      const intersection = selectedColors.filter((color) =>
        filterColorsArray.includes(color)
      );
      selectedColors.length = 0; // Clear the array
      intersection.forEach((color) => selectedColors.push(color));
    } else {
      // Add all filter_colours if selectedColors is empty
      filterColorsArray.forEach((color) => selectedColors.push(color));
    }
    if (selectedColors.length === 0) {
      return ["21345"];
    }
  }

  if (filter_material_colours.length != 0 && filter_colours.length == 0) {
    const filterColorsArray = filter_material_colours.map((color) =>
      color.trim().toLowerCase()
    );

    // If `selectedColors` already has values, keep only the intersection
    if (selectedColors.length > 0) {
      const intersection = selectedColors.filter((color) =>
        filterColorsArray.includes(color)
      );
      selectedColors.length = 0; // Clear the array
      intersection.forEach((color) => selectedColors.push(color));
    } else {
      // Add all filter_colours if selectedColors is empty
      filterColorsArray.forEach((color) => selectedColors.push(color));
    }
    if (selectedColors.length === 0) {
      return ["3456456"];
    }
  }

  if (selectedColors.length === 0) {
    gridContainer?.classList.remove("hide-main-product");
    return []; // No filters applied
  } else {
    gridContainer?.classList.add("hide-main-product");
  }

  // Return all selected colors (no intersection needed)
  return selectedColors;
}

// ======================================================
//  A HELPER TO GENERATE SRCSET FOR IMAGES
// ======================================================
function generateSrcset(baseUrl) {
  const widths = [165, 360, 533, 720, 940, 1066, 1500];
  return widths
    .map((width) => `${baseUrl.split("?")[0]}?width=${width} ${width}w`)
    .join(",");
}

// ======================================================
//  UPDATE VARIANT IMAGE
// ======================================================
function updateVariantImage(variantCard, variant, product) {
  // const variantImageId = variant.image_id;
  // const matchingImage = product.images.find(
  //   (image) => image.id === variantImageId
  // );
  const matchingImage = variant.featured_image?.src;
  const imageElement = variantCard.querySelector(".card__media img");

  if (imageElement && matchingImage) {
    imageElement.src = matchingImage;
    imageElement.srcset = generateSrcset(matchingImage);
    imageElement.setAttribute("data-original-srcset", imageElement.srcset);
  } else if (imageElement) {
    // Fallback to product.featured_image
    imageElement.src = product.image?.src;
    imageElement.alt = product.title;
  }
}

// ======================================================
//  UPDATE VARIANT PRICE
// ======================================================
function updateVariantPrice(variantCard, variant) {
  const regularPrice = variantCard.querySelector(
    ".price__regular .price-item--regular"
  );
  const salePrice = variantCard.querySelector(".price__sale .price-item--sale");
  const strikeThroughPrice = variantCard.querySelector(
    ".price__sale s.price-item--regular"
  );
  const saleSection = variantCard.querySelector(".price__sale");

  // If compare_at_price is greater than price, it's on sale
  if (
    parseFloat(variant.compare_at_price) &&
    parseFloat(variant.price) < parseFloat(variant.compare_at_price)
  ) {
    if (strikeThroughPrice) {
      strikeThroughPrice.textContent = formatPrice(
        variant.compare_at_price,
        "DE"
      );
    }
    if (salePrice) {
      salePrice.textContent = formatPrice(variant.price, "DE");
    }
    if (saleSection) {
      saleSection.style.display = "block";
    }
    if (regularPrice) {
      regularPrice.style.display = "none";
    }
    variantCard.querySelector(".card__badge").style.display = "block";
  } else {
    // Not on sale
    variantCard
      .querySelector(".price.price--on-sale")
      ?.classList.remove("price--on-sale");
    if (regularPrice) {
      regularPrice.textContent = formatPrice(variant.price, "DE");
      regularPrice.style.display = "block";
    }
    if (saleSection) {
      saleSection.style.display = "none";
    }
    variantCard.querySelector(".card__badge").style.display = "none";
  }
}

function sortFilteredItems(items, priorityType = null) {
  const lowerPriorityType = priorityType?.toLowerCase() || ""; // Normalize priorityType to lowercase

  return items.sort((a, b) => {
    const aT = a.t?.toLowerCase() || "";
    const bT = b.t?.toLowerCase() || "";

    // Always place the priority type first
    if (aT === lowerPriorityType) return -1;
    if (bT === lowerPriorityType) return 1;

    // Sort by type (t) descending
    if (aT > bT) return -1;
    if (aT < bT) return 1;

    // If type is the same, sort by colour (c) ascending
    const aC = a.c?.toLowerCase() || "";
    const bC = b.c?.toLowerCase() || "";

    if (aC < bC) return -1;
    if (aC > bC) return 1;

    // If colour is the same, sort by model (m) ascending
    const aM = a.m?.toLowerCase() || "";
    const bM = b.m?.toLowerCase() || "";

    if (aM < bM) return -1;
    if (aM > bM) return 1;

    return 0; // If all fields match, maintain original order
  });
}

function getMatchingVariants() {
  const productGridContainer = document.getElementById("ProductGridContainer");
  if (!productGridContainer) return;

  // Determine if color filters or 24h are active
  const selectedColors = getCurrentFilters();
  const colorFiltersActive = selectedColors.length > 0;
  const is24h = productGridContainer.classList.contains("available-now");
  const modelsFiltered =
    document.querySelectorAll(
      'details[data-filter="filter.p.m.swyft.product_model"] input:checked'
    ).length > 0;
  const typesFiltered =
    document.querySelectorAll(
      'details[data-filter="filter.p.product_type"] input:checked'
    ).length > 0;
  const sizesFiltered =
    document.querySelectorAll(
      'details[data-filter="filter.p.m.swyft.product_seating_capacity"] input:checked'
    ).length > 0;
  if (modelsFiltered || typesFiltered || sizesFiltered) {
    split_model = true;
  } else {
    split_model = false;
  }

  // If neither color filters nor 24h, not split, skip
  if (!colorFiltersActive && !is24h && !split_variants && !split_model) {
    document
      .querySelector(".product-count")
      .classList.remove("hide-whilst-loading");
    return;
  }

  // Initialize total matching variants count
  let totalMatchingVariants = 0;

  // Temporarily disconnect observer to avoid repeated triggers
  gridObserver.disconnect();

  // Iterate over the collection products to calculate matching variants
  window.swyft_collection.forEach((product) => {
    // Get available 24h variant IDs
    const available24hIDs = product.variants
      // .filter((variant) => variant.available) // Replace with your actual condition
      .map((variant) => variant.id);

    // Get matching variants based on the filters
    const matchingVariants = getVariantsByFilters(
      product.variants,
      selectedColors,
      available24hIDs
    );
  });

  // Update the UI for visible grid items
  document.querySelectorAll(".product-grid .grid__item").forEach((card) => {
    const productHandle = card.getAttribute("data-product-handle");
    const product = window.swyft_collection.find(
      (p) => p.handle === productHandle
    );

    if (!product) {
      card.style.display = "none"; // Hide card if no matching product
      return;
    }

    // Filter the product's variants by color & 24h
    const available24hAttr =
      card.querySelector(".card-wrapper")?.getAttribute("data-available-24h") ||
      "";
    const available24hIDs = available24hAttr
      .split(",")
      .map((id) => parseInt(id.trim(), 10)) // Ensure base 10 parsing
      .filter(Number.isInteger); // Filter out any non-integer values

    const matchingVariants = getVariantsByFilters(
      product.variants,
      selectedColors,
      available24hIDs
    );

    if (matchingVariants.length > 0) {
      card.style.display = "block";
      card.setAttribute("data-processed", "true");

      // Use a DocumentFragment to preserve forward order
      const docFrag = document.createDocumentFragment();

      matchingVariants.forEach((variant) => {
        // Add the number of matching variants to the total count
        totalMatchingVariants += 1;
        const variantCard = card.cloneNode(true);
        const variant_id = variant.id;
        const product_title = card.getAttribute("data-product-handle");
        variantCard.setAttribute("data-cloned", "true");
        variantCard.setAttribute("data-price", variant.price);
        variantCard.setAttribute(
          "data-title",
          `${product_title} ${variant.title}`
        );
        let add_to_cart_button =
          variantCard.querySelector(".quick-add__submit");
        add_to_cart_button.setAttribute("data-variant-id", variant_id);

        if (variant.inventory <= 0 && variant.inventory_policy == "CONTINUE") {
          variantCard.querySelector('.quick-add').style.display = "none";
          // Create the button element
          const button = document.createElement("button");
          button.classList.add(
            "quick-add__submit", 
            "button", 
            "button--full-width", 
            "button--secondary", 
            "notify-button"
          );

          // Set the button's text content
          button.textContent = variantCard.querySelector('.card-wrapper').getAttribute('data-notify-text');

          // Add a click event listener to the button
          button.addEventListener("click", () => {
            // Find the modal element with the class 'modal notify-form'
            const modal = document.querySelector(".modal.notify-form");

            if (modal) {
              // Set the display style to block to show the modal
              modal.setAttribute('aria-hidden', "false");
              document.querySelector('notify-form').setAttribute('data-variant-id', variant_id);
              let productId = variantCard.querySelector('.card-wrapper').getAttribute('data-product-id');
              document.querySelector('notify-form').setAttribute('data-product-id', productId);
            } else {
              console.error("Modal element not found!");
            }
          });

          variantCard.querySelector('.card > .card__content').appendChild(button);
        } else {
          // Select the <product-form> element
          let productForm = variantCard.querySelector("product-form");

          // Check if the product form exists
          if (productForm) {
            // Find the add-to-cart button within the product-form
            let addToCartButton =
              productForm.querySelector(".quick-add__submit");

            // If the button exists, move it outside the product-form
            if (addToCartButton) {
              addToCartButton.setAttribute("data-variant-id", variant_id);
              addToCartButton.addEventListener("click", function (e) {
                e.preventDefault();
                addToCart(add_to_cart_button, variant_id);
              });
              // Insert the button before the product-form in the DOM
              productForm.parentNode.insertBefore(addToCartButton, productForm);

              // Remove the product-form element
              productForm.parentNode.removeChild(productForm);
            }
          }
        }
        // Update link for the cloned card
        const variantLinks = variantCard.querySelectorAll(
          "a.full-unstyled-link"
        );
        variantLinks.forEach((link) => {
          link.href = `${Shopify.routes.root}products/${product.handle}?variant=${variant_id}`;
        });

        // Update product title with variant title
        const variantTitle = variantCard.querySelector(".product-title");
        if (variantTitle) {
          let originalText = variantTitle.textContent.trim();
          if (originalText.includes("|")) {
            variantTitle.textContent = originalText.replace(
              /\|.*/,
              `| ${variant.title}`
            );
          } else if (originalText) {
            variantTitle.textContent = `${originalText} | ${variant.title}`;
          } else {
            variantTitle.textContent = variant.title;
          }
        }

        // Update price & image for the cloned card
        updateVariantPrice(variantCard, variant);
        updateVariantImage(variantCard, variant, product);

        variantCard.classList.remove("scroll-trigger--offscreen");
        docFrag.appendChild(variantCard);
      });

      card.parentNode.insertBefore(docFrag, card.nextSibling);
      const gridContainer = document.querySelector(".product-grid-container");
      gridContainer?.classList.add("hide-main-product");
    } else {
      card.style.display = "none"; // Hide card if no matching variants
    }
  });

  let productCount = document.querySelector("#ProductCountDesktop").textContent;
  let parts = productCount.split(" "); // Split the text into parts by the first space
  parts[0] = totalMatchingVariants; // Replace the first part
  let newCount = parts.join(" ");
  document.querySelector("#ProductCountDesktop").textContent = newCount; // Join back the parts

  // Reconnect the observer once done
  gridObserver.observe(productGridContainer, {
    childList: true,
    subtree: true,
  });

  applySorting();

  document
    .querySelector(".product-grid-container")
    .classList.remove("hide-whilst-loading");
  document
    .querySelector(".product-count")
    .classList.remove("hide-whilst-loading");
}

window.addEventListener("swyftCollectionLoaded", () => {
  console.log("Collection loaded:", window.swyft_collection);
  getMatchingVariants();
});

window.addEventListener("load", buildFilterImages);
function updateFilterImages() {
  // Select all facet labels
  let facets = document.querySelectorAll(
    ".facets-layout-list--text .facet-checkbox__text-label"
  );

  let filterImage;
  let model = document.querySelector("span[data-filter-model-hidden]");
  let filteredTypes = document.querySelectorAll(
    'input:checked[name="filter.p.product_type"]:not(.mobile-facets__checkbox)'
  );
  let filteredModels = Array.from(
    document.querySelectorAll(
      'input:checked[name="filter.p.m.swyft.product_model"]:not(.mobile-facets__checkbox)'
    )
  ).map((input) => input.value);

  if (filteredModels.length === 0) {
    const allInputs = Array.from(
      document.querySelectorAll(
        'input[name="filter.p.m.swyft.product_model"]:not(.mobile-facets__checkbox)'
      )
    );

    if (allInputs.length === 1) {
      // Set filteredModels to that single input's value
      filteredModels = allInputs[0].value;
    }
  }

  let filteredColours = Array.from(
    document.querySelectorAll(
      'input:checked[name="filter.v.m.swyft.variant_colour"]:not(.mobile-facets__checkbox)'
    )
  ).map((input) => input.value);

  if (window.colourGroup && typeof window.colourGroup === "string") {
    // Remove surrounding brackets and convert to an array
    filteredColours = window.colourGroup
      .split(",")
      .map((color) => color.trim());
  }

  let first_type = document
    .querySelector("#product-grid .card-wrapper")
    .getAttribute("data-product-type");
  let first_size = document
    .querySelector("#product-grid .card-wrapper")
    .getAttribute("data-product-size");

  facets.forEach((facet) => {
    let facetText = facet.textContent.trim();

    const filterType = Array.from(
      facet.parentElement.parentElement.children
    ).find((sibling) => sibling.tagName === "INPUT");

    filterImage = "";
    if (filterType) {
      switch (filterType.name) {
        case "filter.p.product_type":
          let filteredByType = filterImages.filter(
            (item) => item.t === facetText
          );
          if (filteredColours.length > 0) {
            filteredByType = filteredByType.filter((item) =>
              filteredColours.includes(item.c)
            );
          } else {
            filterByDefaultColour = filteredByType.filter(
              (item) => item.c === "gid://shopify/FilterSettingGroup/144540020"
            );
            if (filterByDefaultColour.length > 0) {
              filteredByType = filterByDefaultColour;
            }
          }
          if (filteredModels.length > 0) {
            filteredByType = filteredByType.filter((item) =>
              filteredModels.includes(item.m)
            );
          }
          let modelName = model?.getAttribute("data-filter-model-hidden");
          if (modelName) {
            filteredByType = filteredByType.filter(
              (item) => item.m === modelName
            );
          }
          const filteredByTypeNonNull = filteredByType.filter(item => item?.url != null);
          filterImage = filteredByTypeNonNull[0]?.url;
          break;
        case "filter.p.m.swyft.product_seating_capacity":
          let filteredBySeating = filterImages.filter(
            (item) => item.s === facetText
          );
          if (filteredColours.length > 0) {
            filteredBySeating = filteredBySeating.filter((item) =>
              filteredColours.includes(item.c)
            );
          } else {
            filteredBySeating = filteredBySeating.filter(
              (item) => item.c === "gid://shopify/FilterSettingGroup/144540020"
            );
          }
          if (filteredModels.length > 0) {
            filteredBySeating = filteredBySeating.filter((item) =>
              filteredModels.includes(item.m)
            );
          }
          filterImage = filteredBySeating[0]?.url;
          break;
        case "filter.p.m.swyft.product_model":
          let filteredByModel = filterImages.filter(
            (item) => item.m === facetText
          );

          if (filteredColours.length > 0) {
            filteredByModel = filteredByModel.filter((item) =>
              filteredColours.includes(item.c)
            );
          } else {
            if (
              filteredByModel.filter(
                (item) =>
                  item.c === "gid://shopify/FilterSettingGroup/144540020"
              ).length > 0
            ) {
              filteredByModel = filteredByModel.filter(
                (item) =>
                  item.c === "gid://shopify/FilterSettingGroup/144540020"
              );
            }
          }

          reserveFilteredByModel = filteredByModel;
          filteredByModel = filteredByModel.filter(
            (item) => item.t === first_type
          );

          let filteredByModelSorted = filteredByModel;

          if (filteredByModelSorted.length === 0) {
            const listItems = document.querySelectorAll(
              'li.list-menu__item.facets__item input[name="filter.p.product_type"]'
            );
            const valuesWithCheckedStatus = Array.from(listItems).map(
              (input) => {
                return { value: input.value, checked: input.checked };
              }
            );
            valuesWithCheckedStatus.sort((a, b) => b.checked - a.checked);
            const sortedTypeValues = valuesWithCheckedStatus.map(
              (item) => item.value
            );
            for (type of sortedTypeValues) {
              // Attempt to filter by the current type
              filteredByModelSorted = reserveFilteredByModel.filter(
                (item) => item.t === type
              );

              // If we found matches, break the loop
              if (filteredByModelSorted.length > 0) {
                break;
              }
            }
          }

          // Now assign the first item's URL to filterImage
          filterImage = filteredByModelSorted[0]?.url;
          break;
        default:
      }
    } else {
      console.log("No input element found");
    }

    // Generate a unique class name to apply the style
    let uniqueClass = `facet-image-${facetText
      .toLowerCase()
      // Replace any character that isn't a-z, 0-9, underscore, or hyphen with a dash
      .replace(/[^a-z0-9_-]+/g, "-")
      // Optionally trim leftover dashes
      .replace(/^-+|-+$/g, "")}`;

    // Add the unique class to the facet
    facet.classList.add(uniqueClass);

    // Create a CSS rule for the ::before pseudo-element
    const style = document.createElement("style");
    style.innerHTML = `
    .${uniqueClass}::before {
      content: "";
      display: block;
      width: auto;
      height: 65px;
      background-image: url(${filterImage});
      background-size: contain;
      background-repeat: no-repeat;
      position: relative;
      top: 0;
      left: 0;
      padding:0;
      margin-bottom: 5px;
      margin-top: 10px;
      aspect-ratio: 2.3;
      background-position: center;
    }
  `;
    // Append the style to the document head
    document.head.appendChild(style);
  });
}

function addToCart(submitButton, variantId, quantity = 1) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  submitButton.querySelector(".loading__spinner").classList.remove("hidden");

  fetch("/cart/add.js", config)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error adding to cart: ${response.statusText}`);
      }
      return response.json();
    })
    .then((cartItem) => {
      console.log("Variant added to cart:", cartItem);
      submitButton.setAttribute("aria-disabled", false);
      submitButton.classList.remove("loading");
      submitButton.querySelector(".loading__spinner").classList.add("hidden");
      cart.renderContents(cartItem);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function formatPrice(price, currency) {

  const numericPrice = Number(price);

  if (currency === "GB") {
    // Format for GBP: No decimals, thousands comma separator
    return `£${Math.round(price).toLocaleString("en-GB", {
      useGrouping: true,
    })}`;
  } else if (currency === "DE") {
    // Format for EUR: Standard format with two decimals, euro sign at the beginning
    return `${numericPrice.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    })}€`;
  } else if (currency === "IE") {
    // Format for EUR: Standard format with two decimals, euro sign at the beginning
    return `€${price.toLocaleString("en-IE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  } else {
    throw new Error("Unsupported currency. Please use 'GBP' or 'EUR'.");
  }
}
